<template>
    <section class="trusted-by">
        <div class="container container--mw-xxl">
            <div class="row justify-content-between">
                <div class="col-12 col-md-4 col-lg-auto">
                    <img src="../../assets/images/logo.png" alt="" class="trusted-by__img">
                </div>

                <div class="col-12 col-md-4 col-lg-auto">
                    <img src="../../assets/images/logo.png" alt="" class="trusted-by__img">
                </div>

                <div class="col-12 col-md-4 col-lg-auto">
                    <img src="../../assets/images/logo.png" alt="" class="trusted-by__img">
                </div>
            </div>

            <p class="trusted-by__copy">Trusted by leading organisations</p>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'TrustedBy',
    }
</script>